import Vue from "vue";
import App from "./App.vue";
import VueLazyLoad from "vue-lazyload";

import("./assets/css/normalize.css");
import("./assets/css/fonticon/iconfont.css");

import router from "./router";

Vue.config.productionTip = false;

Vue.use(VueLazyLoad, {
  error: require("../public/inner/bg/loading.png"),
  loading: require("../public/inner/bg/loading.png")
});

new Vue({
  router,
  // eslint-disable-next-line prettier/prettier
  render: (h) => h(App),
}).$mount("#app");

let ascll = `
8888888888 8888888888 8888888 Y88b   d88P 8888888 888b    888 
888        888          888    Y88b d88P    888   8888b   888 
888        888          888     Y88o88P     888   88888b  888 
8888888    8888888      888      Y888P      888   888Y88b 888 
888        888          888       888       888   888 Y88b888 
888        888          888       888       888   888  Y88888 
888        888          888       888       888   888   Y8888 
888        8888888888 8888888     888     8888888 888    Y888
    `;

console.log(`%c${ascll}`, "color:#161f28");
